import {
  ClosetPlanType,
  InvoiceItemType,
  InvoicePaymentStatus,
  PaymentMethod,
  LegacyPaymentStatus,
  PaymentGatewayType,
} from 'types/plansales/billing';
import { GroupPlanType } from 'types/plansales/plan';
import { InvoiceDetailStatus } from '../../../types/plansales/billing/invoice';

export const paymentInvoiceStatusLabel = {
  [InvoicePaymentStatus.Completed]: 'Completed',
  [InvoicePaymentStatus.Refunded]: 'Refunded', // db 에 invoice 가 생성되고, stripe 에도 invoice 생성되었으나 아직 해당 invoice 가 결제진행되지는 않은 경우
  [InvoicePaymentStatus.Pending]: 'Pending',
  [InvoicePaymentStatus.Uncollectible]: 'Unpaid',
  [InvoicePaymentStatus.None]: 'None',
};

export const paymentInvoiceDetailStatusLabel = {
  [InvoiceDetailStatus.Paid]: 'Completed',
  [InvoiceDetailStatus.Refund]: 'Refunded',
  [InvoiceDetailStatus.Draft]: 'Pending',
  [InvoiceDetailStatus.None]: 'Pending',
  [InvoiceDetailStatus.Open]: 'Pending',
  [InvoiceDetailStatus.Uncollectible]: 'Unpaid',
  [InvoiceDetailStatus.Void]: 'Void',
};

export const legacyPaymentStatusLabel = {
  [LegacyPaymentStatus.CREATED]: 'Pending', // db 에만 invoice 있고, stripe 에는 아직 생성 전 일때
  [LegacyPaymentStatus.TRIED_YET]: 'Pending', // db 에 invoice 가 생성되고, stripe 에도 invoice 생성되었으나 아직 해당 invoice 가 결제진행되지는 않은 경우
  [LegacyPaymentStatus.FAIL]: 'Fail',
  [LegacyPaymentStatus.SUCCESS]: 'Completed',
  [LegacyPaymentStatus.REFUND]: 'Refunded', // cancel after stripe payment
  [LegacyPaymentStatus.VOID]: 'Void', // cancel before stripe payment
  [LegacyPaymentStatus.UN_PAID]: 'Unpaid', // 유예가긴이 완전히 지나고 결제 실패로 끝난 케이스
};

export const paymentMethodLabel = {
  [PaymentMethod.STRIPE]: 'Stripe',
  [PaymentMethod.CREDITS]: 'Invoice', // backoffice 기획 v0.6 따라 라벨을 inv 로 바꾼다
};

export const planTypeLabel = {
  [ClosetPlanType.NONE]: 'None',
  [ClosetPlanType.FREE]: 'Free Plan',
  [ClosetPlanType.ADVANCED_PLAN]: 'Advanced Plan',
  [ClosetPlanType.ADVANCED_PLAN_TRIAL]: 'Advanced Plan Trial',
  [ClosetPlanType.ENTERPRISE]: 'Enterprise Plan',
  [ClosetPlanType.ADVANCED_PLAN_INV]: 'Advanced Plan INV',
};

export const billingInvoiceItemLabel = {
  [InvoiceItemType.FIRST_SUBSCRIPTION]: 'Advanced Plan',
  [InvoiceItemType.RENEW_SUBSCRIPTION]: 'Advanced Plan',
  [InvoiceItemType.CARRY_OVER_BALANCE]: 'Carryover Balance',
  [InvoiceItemType.DOWNGRADE_SUBSCRIPTION]: 'Downgrade to free',
  [InvoiceItemType.REFUND]: 'Refund',
};

export const groupPlanMap: { [key in GroupPlanType]: string } = {
  [GroupPlanType.FREE]: 'Free',
  [GroupPlanType.ADVANCED]: 'Advanced',
  [GroupPlanType.TRIAL]: 'Advanced Trial',
  [GroupPlanType.ENTERPRISE]: 'Enterprise',
  [GroupPlanType.ADVANCED_PLAN_INV]: 'Advanced Plan INV',
  [GroupPlanType.STANDARD]: 'Standard',
  [GroupPlanType.PREMIUM]: 'Premium',
  [GroupPlanType.STANDARD_TRIAL]: 'Standard Trial',
  [GroupPlanType.PREMIUM_TRIAL]: 'Premium Trial',
  [GroupPlanType.STANDARD_INVOICE_PAYMENT]: 'Standard INV',
  [GroupPlanType.PREMIUM_INVOICE_PAYMENT]: 'Premium INV',
  [GroupPlanType.NEW_FREE]: 'Free',
  [GroupPlanType.ACADEMIC]: 'Academic',
  [GroupPlanType.NONE]: 'None',
};

export const paymentGatewayTypeLabel: { [key in PaymentGatewayType]: string } = {
  [PaymentGatewayType.NONE]: 'Invoice',
  [PaymentGatewayType.STRIPE]: 'Stripe',
};
